import { render } from "./PlayingSvg.vue?vue&type=template&id=571333dc"
import script from "./PlayingSvg.vue?vue&type=script&lang=js"
export * from "./PlayingSvg.vue?vue&type=script&lang=js"

import "./PlayingSvg.vue?vue&type=style&index=0&id=571333dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__